// import gql from 'graphql-tag';
// import gqlClient from '../gqlrequest/gqlClient';
// eslint-disable-next-line import/extensions
import {
  retrieveCurrencies,
  retrieveSectors,
  retrieveCountries,
  retrieveCountriesSelected,
  retrieveSectorSelected,
  retrieveOnetJobGroups,
  retrieveOnetJobGroupsByCompanies,
  retrieveMinMaxJobClasses,
  retrieveJobClasses,
  retrieveJobClassesForCompanies,
  retrieveCompanyBenefits,
  retrieveCompanyBenefitsForCompanies,
  retrieveCompanyBenefitsByCompensation,
  retrieveCompanyBenefitsByTopN,
  retrieveCompanies,
  retrieveSalarySummary,
  retrieveCompanyByNameCountryAndRevenue,
  retrieveCompanyByName,
  retrieveAccessRights,
  saveCountriesSelected,
  saveSectorSelected,
  retrieveExecCompUsers,
  saveExecCompUser,
} from '../apis/rpcs';

export default {
  queryAccessRight({ commit }) {
    retrieveAccessRights().then((resp) => commit('setAccessRights', resp));
    // gqlClient.request(gql`{accessRights}`, {}, { cache: false })
    // .then((resp) => commit('setAccessRights', resp.accessRights));
  },
  queryExecCompUsers() {
    return retrieveExecCompUsers();
    // return gqlClient.request(gql`{
    //   execCompUsers {
    //     userID
    //     userName
    //     company
    //     countriesSubscribed
    //   }
    // }`, {}, { cache: false });
  },
  queryCompanyByNameCountryAndRevenue(ctx, input) {
    return retrieveCompanyByNameCountryAndRevenue(input);
    // return gqlClient.request(gql`
    //   query CompanyByNameCountryAndRevenue($input:CompanyByNameCountryAndRevenueInput!){
    //     companyByNameCountryAndRevenue(input:$input){
    //       company
    //       sector
    //       country
    //       positions{
    //         MRCJobClass
    //       }
    //     }
    //   }`, { input });
  },
  queryPublicCompaniesByName(ctx, name) {
    return retrieveCompanyByName(name);
    // return gqlClient.request(gql`
    //   query companiesByName($name:String!){
    //     companyByName(name:$name){
    //       ticker
    //       company
    //       revenue
    //       profit
    //       sector
    //       country
    //     }
    //   }`, { name });
  },
  queryPublicCompanies(ctx, input) {
    return retrieveCompanies(input);
    // return gqlClient.request(gql`
    //   query companies($input:companyFilter!){
    //     companies(input:$input){
    //       ticker
    //       company
    //       revenue
    //       profit
    //       sector
    //       country
    //     }
    //   }`, { input });
  },
  querySalarySummary(ctx, input) {
    return retrieveSalarySummary(input);
    // return gqlClient.request(gql`
    //   query salarySummary($input: salarySummaryInput!){
    //     salarySummary(input:$input){
    //       min
    //       max
    //       noOfPositions
    //       median
    //       mean
    //     }
    //   }`, {
    //   input,
    // });
  },
  queryCompanyBenefitsByCompensation(ctx, input) {
    return retrieveCompanyBenefitsByCompensation(input);
    // return gqlClient.request(gql`
    // query CompanyBenefitsByCompensation($input:CompanyBenefitsByCompensationInput!) {
    //   companyBenefitsByCompensation(input: $input){
    //       company
    //       revenue
    //       profit
    //       ticker
    //       sector
    //       country
    //       positions{
    //         countryCode
    //         fy
    //         jobGroup
    //         title
    //         name
    //         MRCJobClass
    //         bonusUSD
    //         nonEquityUSD
    //         optionAwardUSD
    //         otherUSD
    //         pensionUSD
    //         salaryUSD
    //         stockAwardUSD
    //         allowanceUSD
    //         perquisiteUSD
    //         fixedCashUSD
    //         totalCashUSD
    //         totalDirectCompensationUSD
    //         totalRemunerationUSD
    //         totalCostUSD

    //         lowerBandUSD
    //         upperBandUSD
    //         salaryRatio
    //         allowanceRatio
    //         discretionaryBonusRatio
    //         shareBasedPaymentRatio
    //         deferredCashRatio
    //         benefitsInKindRatio
    //         socialContributionRatio
    //         otherRatio
    //         directorFeeRatio
    //         isExact
    //         discretionaryBonusUSD
    //         shareBasedPaymentUSD
    //         deferredCashUSD
    //         benefitsInKindUSD
    //         socialContributionUSD
    //         directorFeeUSD
    //         remarks
    //         screenshots
    //         prorate
    //         selected
    //       }
    //     }
    // }`, { input });
  },
  queryCompanyBenefitsByTopN(ctx, input) {
    return retrieveCompanyBenefitsByTopN(input);
    // return gqlClient.request(gql`
    // query CompanyBenefitsByTopN($input:CompanyBenefitsByTopNInput!) {
    //   companyBenefitsByTopN(input: $input){
    //       company
    //       revenue
    //       profit
    //       ticker
    //       sector
    //       country
    //       positions{
    //         countryCode
    //         fy
    //         jobGroup
    //         title
    //         name
    //         MRCJobClass
    //         bonusUSD
    //         nonEquityUSD
    //         optionAwardUSD
    //         otherUSD
    //         pensionUSD
    //         salaryUSD
    //         stockAwardUSD
    //         allowanceUSD
    //         perquisiteUSD
    //         fixedCashUSD
    //         totalCashUSD
    //         totalDirectCompensationUSD
    //         totalRemunerationUSD
    //         totalCostUSD

    //         lowerBandUSD
    //         upperBandUSD
    //         salaryRatio
    //         allowanceRatio
    //         discretionaryBonusRatio
    //         shareBasedPaymentRatio
    //         deferredCashRatio
    //         benefitsInKindRatio
    //         socialContributionRatio
    //         otherRatio
    //         directorFeeRatio
    //         isExact
    //         discretionaryBonusUSD
    //         shareBasedPaymentUSD
    //         deferredCashUSD
    //         benefitsInKindUSD
    //         socialContributionUSD
    //         directorFeeUSD
    //         remarks
    //         screenshots
    //         prorate
    //         selected
    //       }
    //     }
    // }`, { input });
  },
  queryCompanyBenefitsForCompanies(ctx, input) {
    return retrieveCompanyBenefitsForCompanies(input);
    // return gqlClient.request(gql`
    // query CompanyBenefitsForCompanies($input:CompanyBenefitsForCompaniesInput!) {
    //   companyBenefitsForCompanies(input: $input){
    //       company
    //       revenue
    //       profit
    //       ticker
    //       sector
    //       country
    //       positions{
    //         countryCode
    //         fy
    //         jobGroup
    //         title
    //         name
    //         MRCJobClass
    //         bonusUSD
    //         nonEquityUSD
    //         optionAwardUSD
    //         otherUSD
    //         pensionUSD
    //         salaryUSD
    //         stockAwardUSD
    //         allowanceUSD
    //         perquisiteUSD
    //         fixedCashUSD
    //         totalCashUSD
    //         totalDirectCompensationUSD
    //         totalRemunerationUSD
    //         totalCostUSD

    //         lowerBandUSD
    //         upperBandUSD
    //         salaryRatio
    //         allowanceRatio
    //         discretionaryBonusRatio
    //         shareBasedPaymentRatio
    //         deferredCashRatio
    //         benefitsInKindRatio
    //         socialContributionRatio
    //         otherRatio
    //         directorFeeRatio
    //         isExact
    //         discretionaryBonusUSD
    //         shareBasedPaymentUSD
    //         deferredCashUSD
    //         benefitsInKindUSD
    //         socialContributionUSD
    //         directorFeeUSD
    //         remarks
    //         screenshots
    //         prorate
    //         selected
    //       }
    //     }
    // }`, { input });
  },
  queryCompanyBenefits(ctx, input) {
    return retrieveCompanyBenefits(input);
    // return gqlClient.request(gql`
    //   query ($input:companyBenefitsInput!) {
    //     companyBenefits(input: $input){
    //       company
    //       revenue
    //       profit
    //       positions{
    //         countryCode
    //         fy
    //         jobGroup
    //         title
    //         name
    //         MRCJobClass
    //         bonusUSD
    //         nonEquityUSD
    //         optionAwardUSD
    //         otherUSD
    //         pensionUSD
    //         salaryUSD
    //         stockAwardUSD
    //         allowanceUSD
    //         perquisiteUSD
    //         fixedCashUSD
    //         totalCashUSD
    //         totalDirectCompensationUSD
    //         totalRemunerationUSD
    //         totalCostUSD

    //         lowerBandUSD
    //         upperBandUSD
    //         salaryRatio
    //         allowanceRatio
    //         discretionaryBonusRatio
    //         shareBasedPaymentRatio
    //         deferredCashRatio
    //         benefitsInKindRatio
    //         socialContributionRatio
    //         otherRatio
    //         directorFeeRatio
    //         isExact
    //         discretionaryBonusUSD
    //         shareBasedPaymentUSD
    //         deferredCashUSD
    //         benefitsInKindUSD
    //         socialContributionUSD
    //         directorFeeUSD
    //         remarks
    //         screenshots
    //         prorate
    //         selected
    //       }
    //     }
    //   }`, { input });
  },
  queryJobClasses(ctx, input) {
    return retrieveJobClasses(input);
    // return gqlClient.request(gql`
    // query JobClasses($input:jobClassesInput!) {
    //   jobClasses(input: $input)
    // }`, { input });
  },
  queryMinMaxJobClasses({ commit }, input) {
    commit('setMinMaxLoading', true);

    retrieveMinMaxJobClasses(input)
      .then((data) => {
        if (!data) {
          commit('setMinMaxJobClasses', { min: -1, max: -1 });
        } else if (data.min !== -1 || data.max !== 0) {
          commit('setMinMaxJobClasses', data);
        } else {
          commit('setMinMaxJobClasses', { min: -1, max: -1 });
        }
        commit('setMinMaxLoading', false);
      })
      .catch(() => {
        commit('setMinMaxJobClasses', { min: -1, max: -1 });
        commit('setMinMaxLoading', false);
      });

    // gqlClient.request(gql`
    // query minMaxJobClasses($input:minMaxJobClassesInput!) {
    //   minMaxJobClasses(input: $input){
    //     min
    //     max
    //   }
    // }`, { input })
    //   .then((data) => {
    //     if (!data.minMaxJobClasses) {
    //       commit('setMinMaxJobClasses', { min: -1, max: -1 });
    //     } else if (data.minMaxJobClasses.min !== -1 || data.minMaxJobClasses.max !== 0) {
    //       commit('setMinMaxJobClasses', data.minMaxJobClasses);
    //     } else {
    //       commit('setMinMaxJobClasses', { min: -1, max: -1 });
    //     }
    //     commit('setMinMaxLoading', false);
    //   })
    //   .catch(() => {
    //     commit('setMinMaxJobClasses', { min: -1, max: -1 });
    //     commit('setMinMaxLoading', false);
    //   });
  },
  mutateExecCompUser(ctx, user) {
    return saveExecCompUser(user);
    // return gqlClient.request(gql`
    //   mutation($user:UserInput!){
    //     saveExecCompUser(user:$user)
    // }`, { user });
  },
  mutateCountriesSelected({ commit }, countries) {
    return saveCountriesSelected(countries)
      .then((data) => {
        if (data) {
          commit('setCountriesSelected', countries);
        }
        return data;
      });

    // return gqlClient.request(gql`
    // mutation($countries: [CountryInput!]!) {
    //   setCountriesSelected(countries: $countries)
    // }`, {
    //   countries,
    // }).then((data) => {
    //   if (data.setCountriesSelected) {
    //     commit('setCountriesSelected', countries);
    //   }
    //   return data.setCountriesSelected;
    // });
  },
  queryJobClassesInCompanies(ctx, input) {
    return retrieveJobClassesForCompanies(input);
    // return gqlClient.request(gql`
    // query JobClassesForCompanies($input:jobClassesForCompaniesInput!) {
    //   jobClassesForCompanies(input: $input)
    // }`, { input });
  },
  queryCountriesSelected({ commit }) {
    return retrieveCountriesSelected().then((data) => {
      commit('setCountriesSelected', data);
      return data;
    }).catch((err) => {
      console.error(err);
      return [];
    });

    // return gqlClient.request(gql`{
    //   countriesSelected {
    //     countryName
    //     countryCode
    //   }
    // }`).then((data) => {
    //   if (data.countriesSelected) {
    //     commit('setCountriesSelected', data.countriesSelected);
    //     return data.countriesSelected;
    //   }
    //   return [];
    // });
  },
  queryOnetJobGroups(ctx, { sectors, countryCodes }) {
    return retrieveOnetJobGroups({
      sectorNames: sectors,
      countryCodes,
    });

    // return gqlClient.request(gql`
    //   query onetJobGroups($selectedSectorNames:[String!], $countryCodes:[String!]!) {
    //     onetJobGroups(sectorNames: $selectedSectorNames, countryCodes: $countryCodes)
    // }`, {
    //   selectedSectorNames: sectors,
    //   countryCodes,
    // });
  },
  queryOnetJobGroupsByCompanies(ctx, companies) {
    return retrieveOnetJobGroupsByCompanies(companies);

    // return gqlClient.request(gql`
    //   query onetJobGroupsByCompanies($companies:[String!]!) {
    //     onetJobGroupsByCompanies(companies: $companies)
    // }`, {
    //   companies,
    // });
  },
  querySectorSelected({ commit }) {
    retrieveSectorSelected().then((data) => {
      commit('setSectorSelected', data);
    }).catch((err) => {
      console.error(err);
      commit('setSectorSelected', { name: '' });
    });

    // gqlClient.request(gql`{
    //   sectorSelected{
    //     name
    //   }
    // }`).then((data) => {
    //   if (data.sectorSelected) {
    //     commit('setSectorSelected', data.sectorSelected);
    //   } else {
    //     commit('setSectorSelected', { name: '' });
    //   }
    // });
  },
  mutateSectorSelected({ commit }, sector) {
    saveSectorSelected(sector)
      .then((data) => {
        if (data) {
          commit('setSectorSelected', data);
        }
      });

    // gqlClient.request(gql`
    //   mutation($sector: SectorInput!) {
    //     setSectorSelected(sector: $sector) {
    //       name
    //     }
    //   }`, {
    //   sector,
    // }).then((data) => {
    //   if (data.setSectorSelected) {
    //     commit('setSectorSelected', data.setSectorSelected);
    //   }
    // });
  },
  queryCurrency({ commit }) {
    retrieveCurrencies().then((data) => {
      if (data) {
        commit('setCurrencies', data);
      }
    }).catch((err) => console.error(err));

    // gqlClient.request(gql`{
    //   currencies{
    //     region
    //     continent
    //     currencyCode
    //     countryCode
    //     countryName
    //     usdDivisor
    //   }
    // }`).then((data) => {
    //   if (data.currencies) {
    //     commit('setCurrencies', data.currencies);
    //   }
    // });
  },
  querySectorsCountries({ commit }) {
    retrieveSectors().then((data) => {
      commit('setSectors', data);
    }).catch((err) => {
      console.error(err);
    });
    retrieveCountries('').then((data) => {
      commit('setCountries', data);
    }).catch((err) => {
      console.error(err);
    });
  },
};
